import React from 'react';

const Header = ({ platform, username, url, avatarUrl, bio }) => (
    <header>
        <h2 style={styles.cmdTitle}>&gt;cmd_</h2>
    </header>
);

const styles = {
    cmdTitle: {
        fontFamily: 'monospace',
        fontSize: 'xx-large',
        fontWeight: 700,
        margin: '1rem'
    },
};

export default Header;